export default {
  title: '黑名单管理',
  tip: '加入黑名单的会员将无法参与任何会员活动，可在此处管理黑名单成员。',
  columns: {
    id: '会员ID',
    nickname: '会员昵称',
    level: '会员等级',
    country: '所在国家',
    email: '邮箱',
    phone: '手机号',
    wechat: '微信号',
    registerTime: '注册时间',
  },
  actions: {
    remove: '撤销黑名单',
  },
  removeConfirm: {
    title: '确定将该用户撤销黑名单吗？',
    tip: '撤销黑名单后，该用户将正常参与所有活动。',
  },
};
